export default __webpack_public_path__ + "static/media/000_intro_part2.hevc.f76ac1a2.mp4";